import '../css/ticket.css';

export default function TicketCard({ ticket,showLogo,showTerminal,showPrice  }) {
  return (
    <div id='asli'>
        <div className="ticket-wrapper crs">
      {/* محتویات اصلی کارت */}
      <div className="ticket-main">
        {/* HEADER با فضای لوگو */}
        <div className="ticket-header crs-header" style={{ display: 'flex', alignItems: 'center' }}>


<div className="ticket-header crs-header" style={{ display: 'flex', alignItems: 'center' }}>
  {showLogo && (
    <div className="ticket-logo" style={{position:'relative',top:'-20px'}}>
      <img
        src="/logo.png"
        alt="Logo"
        style={{ width: '120px', height: '120px', marginRight: '10px' }}
      />
    </div>
  )}

</div>


 <div className='text-center' style={{paddingTop:'45px'}}>
          <span className='d-block' style={{paddingBottom:'30px'}}>{ticket.cabinClass}</span>
            <span>👤 نوع مسافر : {ticket.passengerType}</span>
 </div>

        </div>

        {/* خط افقی جداکننده */}
        <div className="ticket-divider"></div>

        {/* متا */}
        <div className="ticket-meta crs-meta">
          <span>نام مسافر : <strong>{ticket.passenger}</strong></span>
          <span>تاریخ صدور  : {ticket.issueDate}</span>
        </div>

        <div className="ticket-body crs-grid text-center">
          <div>
            <label>شهر مبدا :</label>
            <strong>{ticket.fromCity}</strong>

            <label style={{display:'none'}}>فرودگاه مبدا :</label>
            <strong style={{display:'none'}}>{ticket.fromAirport}</strong>
 <label>ساعت و تاریخ پرواز :</label>
            <strong>{ticket.departureTime}</strong>
            <div className="muted">{ticket.departureDate}</div>
          </div>

          <div>
            <label>شهر مقصد :</label>
            <strong>{ticket.toCity}</strong>
          </div>
        </div>


       


<div className={`ticket-body crs-grid ${showTerminal ? 'dashed' : ''}`}>
  <div>
    {showTerminal && (
      <>
        <label>ترمینال خروجی :</label>
        <strong>{ticket.fromTerminal}</strong>
      </>
    )}
  </div>
</div>


           
          
      

   
     

        <div className="footer crs-footer" style={{direction:'ltr'}}>



  {showPrice && (
        <span style={{fontSize:'18px'}}>          مجموع قیمت:
               &nbsp;
               <strong>
   {ticket.totalPrice.toLocaleString('en-US')}
               </strong>
           
              &nbsp;
               ریال
               
               </span>
  )}


  

         
        
        </div>
      </div>

     {/* ستون سمت راست */}
      <div className="ticket-side text-center">
        <div className="ticket-side-item">
          <label style={{fontSize:'20px',color:'#46a7fd'}}>بلیط رفت</label>
        </div>

        <div className="ticket-side-item">
          <label>✈ ایرلاین :</label>
          <strong>{ticket.airline}</strong>
        </div>
        <div className="ticket-side-item">
          <label>شماره پرواز :</label>
          <strong>{ticket.flightNumber}</strong>
        </div>

        
      </div>


      
    </div>

   {/* بخش جزئیات قیمت */}
   <div style={{width:'100%'}} className='text-center m-auto' >
 

        {/* بخش قوانین و مقررات */}
<div className="ticket-rules text-left">
  <h4>قوانین و مقررات</h4>
  <ol className="fa-list">
    <li>طبق قوانین ایرلاین، هزینه‌های کنسلی محاسبه می‌گردد.</li>
    <li>حضور مسافر حداقل یک ساعت قبل از پرواز در فرودگاه الزامی می‌باشد.</li>
    <li>
      این شرکت هیچ‌گونه مسئولیتی در خصوص عدم پذیرش مسافر نخواهد داشت و کلیه
      خسارات در صورت ایجاد هرگونه محدودیت در پذیرش مسافر، متوجه خریدار می‌باشد.
    </li>
    <li>
 شماره پشتیبانی:
 &nbsp;
    <strong>09124017826</strong>
</li>
  </ol>
</div>
</div>

    </div>
  
    
  );
}
